/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'done2': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 6',
    data: '<path pid="0" d="M8 1.2L4.261 4.8 3.015 6 1.769 4.8l.007-.007L0 3.066l1.247-1.2 1.775 1.728L6.754 0z" fill-rule="evenodd"/>'
  }
})
